<script>
    import PatientEncounterEmailTemplatesTable from "../components/PatientEncounterEmailTemplatesTable.svelte";
    import PatientEncounterSmsTemplatesTable from "../components/PatientEncounterSmsTemplatesTable.svelte";
    import { PageLoading } from "../../../Components/Common/index.svelte";

    export let patientEncounterDetails = {},
        isLoading = false,
        patientDetails = {},
        doctorDetails = {},
        emailNotifications = {},
        smsNotifications = {},
        reloadCommunication = () => {};
</script>

{#if isLoading}
    <PageLoading />
{:else}
    <div class="relative flex-1">
        <div class="flex flex-col overflow-y-auto absolute inset-0 gap-4 mt-4">
            <PatientEncounterEmailTemplatesTable
                {patientEncounterDetails}
                {emailNotifications}
                {reloadCommunication}
            />

            <PatientEncounterSmsTemplatesTable
                {patientDetails}
                {doctorDetails}
                {patientEncounterDetails}
                {smsNotifications}
                {reloadCommunication}
            />
        </div>
    </div>
{/if}
